<template>
  <div>
    <a-input
      :value="time"
      @change="onTimeChange"
      placeholder="hh:mm"
      :maxLength="5"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      time: '' // Estado para almacenar la hora ingresada
    }
  },
  methods: {
    onTimeChange (e) {
      let value = e.target.value

      // Validar el formato de hora (h:mm o hh:mm)
      const regex = /^([0-1]?\d|2[0-3]):([0-5]\d)$/
      if (regex.test(value)) {
        // Asegurar que la hora siempre tenga dos dígitos
        value = value.replace(/^(\d):/, '0$1:')
        this.time = value
      } else {
        this.time = '' // Limpiar si el formato es incorrecto
      }
      this.$emit('change', this.time)
    }
  },
  mounted () {
    // Inicializar la hora con el valor pasado como prop
    this.time = this.value || ''
  }
}
</script>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
